import clsx from "clsx";
import { type HTMLAttributes } from "react";

import styles from "components/ui/Statistic/Value.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    weight?: "normal" | "bold";
};

export const Value = (props: Props) => {
    const { className, weight = "normal", ...otherProps } = props;

    return <div {...otherProps} className={clsx(styles.value, className)} data-weight={weight} />;
};
